// KPICard.tsx
import React from "react";
import { KPICardProps } from "../types/revenue.types";
import RevenueService from "../../../services/revenueService";

export const KPICard: React.FC<KPICardProps> = ({
  icon,
  title,
  value,
  subtitle,
  colorTheme,
  trend,
}) => {
  return (
    <div
      style={{
        background: colorTheme.cardBg,
        borderRadius: "12px",
        padding: "24px",
        boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          marginBottom: "12px",
        }}
      >
        <div style={{ fontSize: "32px" }}>{icon}</div>
        {trend && (
          <div
            style={{
              fontSize: "14px",
              fontWeight: "600",
              color: trend.isPositive ? colorTheme.success : colorTheme.error,
              background: trend.isPositive ? "#ecfdf5" : "#fef2f2",
              padding: "4px 8px",
              borderRadius: "6px",
            }}
          >
            {trend.isPositive ? "↑" : "↓"}{" "}
            {RevenueService.formatPercentage(trend.value)}
          </div>
        )}
      </div>
      <div style={{ marginBottom: "4px" }}>
        <div
          style={{
            fontSize: "14px",
            fontWeight: "500",
            color: colorTheme.gray600,
            marginBottom: "4px",
          }}
        >
          {title}
        </div>
        <div
          style={{
            fontSize: "28px",
            fontWeight: "700",
            color: colorTheme.gray900,
          }}
        >
          {typeof value === "number"
            ? RevenueService.formatCurrency(value)
            : value}
        </div>
      </div>
      {subtitle && (
        <div style={{ fontSize: "12px", color: colorTheme.gray500 }}>
          {subtitle}
        </div>
      )}
    </div>
  );
};
